// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import ZendeskFooter from '../components/login/zendesk/footer';
import TVEFooter from '../components/login/tve/footer';
import {
  getZendeskUrlRedirect,
  getOauthUrlRedirect,
  getCannyUrlRedirect,
  getESPNActivateUrlRedirect,
} from './url-helpers';
import { Footer } from '../components/login';
import { extractUrlParams } from './zendesk/extract-url-params';
import { environment } from '../environments';
import { copyUrlParams } from '../utils/route';

const formConfigs = {
  TVE: {
    urlBuilder: getOauthUrlRedirect,
    footer: TVEFooter,
  },
  OAUTH: {
    urlBuilder: getOauthUrlRedirect,
    footer: Footer,
  },
  ZENDESK: {
    urlBuilder: getZendeskUrlRedirect,
    footer: ZendeskFooter,
    extractAdditionalUrlParams: extractUrlParams,
  },
  CANNY: {
    urlBuilder: getCannyUrlRedirect,
    footer: Footer,
  },
  ESPN_ACTIVATE: {
    urlBuilder: getESPNActivateUrlRedirect,
    footer: TVEFooter,
  },
  ESPN_ACTIVATE_DISNEY: {
    urlBuilder: getESPNActivateUrlRedirect,
    footer: TVEFooter,
  },
};

const getFormConfig = (formType) => {
  const conf = formConfigs[formType];
  return {
    ...conf && conf.extractAdditionalUrlParams ? conf.extractAdditionalUrlParams() : {},
    ...conf,
  };
};

const getFormEnvironmentConfig = (formType) => {
  const formConfig = environment.formConfig[formType];
  return {
    signInUrl: copyUrlParams(`${environment.api}${formConfig.loginFormPath}`),
  };
};

export const getConfig = (formType: string) => ({
  ...getFormEnvironmentConfig(formType),
  ...getFormConfig(formType),
});
